import React from 'react'
import "./HomeBanner.css";
import star from "../../assets/imgs/icons/star.svg";
import { Link } from "react-router-dom";
import { Button } from "@mui/material";
import PropTypes from "prop-types";

function HomeBanner({ open, openContactForm }) {


  const handleWhatsApp = () => {
    window.open("https://wa.me/919876543210", "_blank"); 
  };


  const handleScroll = () => {
    const section = document.querySelector(".gtinTch"); 
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
   <div className='bnrTop'>
       <div className="maxW">
          <div className="bnrcon">
            <h3>“Solutions Simplified”</h3>
          <div>
             <h1>Your All-in-One Partner for Payments, Tech, Business & Marketing Excellence</h1>
          </div>

         <div className='bnrhdWrp'>
             <p>Fuel your growth with expert solutions</p>
             <div className='starWrp'>
               <img src={star} alt="star" />
            </div>
         </div>

          <div className='webBtns'>
              <Button variant="contained" onClick={openContactForm}>
        Let's Talk
      </Button>
            
                 <Button
              variant="contained"
              component={Link}
              to="/contact-us"
              className="wbtnLink"
            >
              Contact Us
            </Button>
          </div>
         </div>
       </div>
   </div>
  )
}
HomeBanner.propTypes = {
  open: PropTypes.bool,
  openContactForm: PropTypes.bool,
};

HomeBanner.defaultProps = {
  open: false,
  openContactForm: false,
};
export default HomeBanner
